<script>
import formatTextUpperCasefirst from "@utils/format-text-upper-casefirst";

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    titleClass: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    subTitleClass: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    descriptionClass: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'normal',
      validator(value) {
        return [
          'normal',
        ].includes(value)
      },
    },
    tip: {
      type: String,
      default: ''
    },
  },
  methods: {
    formatTextUpperCasefirst,
  }
}
</script>
<!-- section template -->
<template>
  <div :class="[$style.baseSectionTitleJtails, $style[`isStyle${formatTextUpperCasefirst(type)}`], { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
    <h2
      v-if="!!title"
      :class="titleClass"
      class="baseSectionTitleJtails__title"
    >
      <div
        v-if="!!subTitle && $globalIsDingBeauty"
        :class="subTitleClass"
        class="baseSectionTitleJtails__subTitle isStyleDingbeauty"
        v-html="subTitle"
      ></div>
      <span v-html="title"></span>
      <span v-if="!!tip">
        <el-popover
          placement="right"
          width="300"
          trigger="hover"
        >
          <BaseButton
            slot="reference"
            class="isStylePrimary isText ml-1"
          >
            <i class="fontello fontello-attention fs-lg" style="position: relative;top: -2px;"></i>
          </BaseButton>
          <span v-html="tip"></span>
        </el-popover>
      </span>
    </h2>
    <div
      v-if="!!subTitle && $globalIsJtails"
      :class="subTitleClass"
      class="baseSectionTitleJtails__subTitle"
      v-html="subTitle"
    ></div>
    <p
      v-if="!!description || !!$slots['description']"
      :class="descriptionClass"
      class="baseSectionTitleJtails__description"
    >
      <slot v-if="!!$slots['description']" name="description"/>
      <span v-else v-text="description"></span>
    </p>
  </div>
</template>
<!-- section style -->
<style lang="scss" module>
.baseSectionTitleJtails {
  margin-bottom: 1.5rem;

  @include max-lg {
    margin-bottom: 1rem;
  }

  :global {
    .baseSectionTitleJtails {
      &__title {
        margin-bottom: 0.25rem;
        font-family: $font-serif;
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 1.5;
        color: #3F3A2E;
        letter-spacing: 0.2em;

        @include max-lg {
          font-size: 1.5rem;
        }
      }
      // &__divider {
      //   height: 1px;
      //   width: 75px;
      //   border: 1px solid $color-primary;
      //   margin-bottom: 1.125px;
      //   margin-top: 1rem;
      //   @media (max-width: 768px) {
      //       display: none;
      //   }
      // }
      &__subTitle {
        font-family: $font-playfair-italic;
        font-size: 0.875rem;
        color: $color-secondary;
        &.isStyleDingbeauty {
          font-family: $font-playfair;
          font-size: $color-text;
          font-weight: 400;
          letter-spacing: 0;
        }
      }

      &__description {
        margin-top: 1rem;
        margin-bottom: 0;
        font-size: 0.875rem;
        line-height: 1.75;
        color: #3F3A2E;
        white-space: pre-wrap;

        a {
          color: #3F3A2E;

          &:hover {
            color: $color-primary;
          }
        }
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .baseSectionTitleJtails {
        &__title {
          font-weight: 400;
          color: $color-secondary;
          position: relative;
          margin-bottom: 2.5rem;
          &:before {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            height: 1px;
            bottom: -0.8rem;
            width: 75px;
            border: 1px solid $color-primary;
            @media (max-width: 768px) {
                display: none;
            }
          }
          &.isStyleDNone {
            &:before {
              display: none;
            }
          }
          &.isCenter {
            &:before {
              margin: 0 auto;
            }
          }
        }
      }
    }
    &:global {
      
    }
  }
}
</style>
